"use client";

import { NuqsAdapter } from 'nuqs/adapters/next';

// 安全なNuqsAdapterコンポーネント
export const SafeNuqsAdapter = ({ children }: { children: React.ReactNode }) => {
  // SSR時はアダプターを使用しない
  if (typeof window === 'undefined') {
    return <>{children}</>;
  }

  // クライアントサイドでは常にアダプターを使用
  return <NuqsAdapter>{children}</NuqsAdapter>;
}; 